import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { acessosTabelaPreco } from '../../../../home/tabela-preco/can-activate-tabela-preco';
import { UsuarioPerfil, usuarioPerfilRepresentante } from '../../../../home/usuario/usuario-perfil';

export const acessosListagemTabelaPreco: UsuarioPerfil[] = [...acessosTabelaPreco, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateTabelasPrecosListagem implements CanActivate {
  constructor(private authGuard: AuthGuard, private authService: AuthService) {}

  canActivate(): boolean {
    return this.authService.podeAcessarTabelasPrecos() && this.authGuard.canActivateAcesso(acessosListagemTabelaPreco);
  }
}
